import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-arrow-left-02',
	templateUrl: './icon-arrow-left-02.component.svg',
})
export class IconArrowLeft02Component {}
